import {
    ADAPTIVE_MODE,
} from 'helpers/adaptive';

export function formatManualAdaptiveMode(manualAdaptiveMode: ADAPTIVE_MODE | null): string {
    switch (manualAdaptiveMode) {
        case ADAPTIVE_MODE.DESKTOP: {
            return 'Desktop version';
        }
        case ADAPTIVE_MODE.MOBILE: {
            return 'Mobile version';
        }
        case null: {
            return 'Default version';
        }
    }
}
